module.exports = __webpack_public_path__ + "static/media/advantage_2.02a481f0.png";